import { baseApi } from './baseApi';

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    clinicSettings: build.query({
      query: () => '/clinic-settings',
      transformResponse: (resp) => resp.data,
      providesTags: ['ClinicSettings'],
    }),
    updateClinicSettings: build.mutation({
      query: (body) => ({ url: '/clinic-settings', method: 'PUT', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['ClinicSettings'],
    }),
    addHoliday: build.mutation({
      query: (body) => ({ url: '/clinic-settings/holidays', method: 'POST', body }),
      transformResponse: (resp) => resp.data,
      invalidatesTags: ['ClinicSettings'],
    }),
    removeHoliday: build.mutation({
      query: (id) => ({ url: `/clinic-settings/holidays/${id}`, method: 'DELETE' }),
      invalidatesTags: ['ClinicSettings'],
    }),
  }),
});

export const {
  useClinicSettingsQuery,
  useUpdateClinicSettingsMutation,
  useAddHolidayMutation,
  useRemoveHolidayMutation,
} = settingsApi;
